/**
 * A save rejection carries {code, message} from the platform error handler. Prefer the
 * server's message (it names the offending domain) and fall back to the code so the alert
 * is never an empty or opaque "Save failed".
 *
 * Lives in utils/ rather than beside the Stores form because `actions/` imports it, and
 * an action reaching into `views/` is the one direction that split exists to prevent.
 * The api layer rejects with `error.response` (src/utils/index.js), so `status` and
 * `data` are both top-level on what arrives here. When the request never reached the server
 * there is no response, and the axios error arrives instead — it has `message` but no `data`
 * or `status`, which is why every read below is guarded.
 */
export function saveErrorMessage(err) {
  const body = (err && err.data) || {};
  // the in-use message interpolates a Java list, so it arrives as '[a.com]' — read as a domain
  if (body.message) return body.message.replace(/'\[([^[\]]*)\]'/g, "'$1'");
  if (body.code) return `Save failed (${body.code})`;
  if (err && err.status === 409) return 'That domain is already used by another store';
  return 'Save failed';
}
